<script setup lang="ts">
import LottieAnimation from '@/components/ui/LottieAnimation.vue';
import animatedBus from '@/assets/img/animatedBus.json';
</script>

<template>
  <div class="page page--no-navbar loading-screen">
    <LottieAnimation :animation-data="animatedBus" class="loading-screen__animation" />
    <p class="loading-screen__label" role="status">{{ $t('common.loadingGTFS') }}</p>
  </div>
</template>

<style scoped lang="scss">
.loading-screen {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $color-white;

  &__animation {
    width: min(280px, 70vw);
    aspect-ratio: 1;
  }

  &__label {
    margin: 0;
    font: $label-medium;
    letter-spacing: $label-medium-spacing;
    color: $color-text-neutral;
    text-align: center;
  }
}
</style>
